<template>
  <tr>
    <td width="35%">{{ item.account.number }} {{ item.account.name }}</td>
    <td width="35%" class="sf-c-text-light">
      {{ item.description }}
    </td>
    <td v-dompurify-html="debit" width="15%" class="sf-alignr sf-nowrap" />
    <td v-dompurify-html="credit" width="15%" class="sf-alignr sf-nowrap" />
  </tr>
</template>

<script setup lang="ts">
import { SubAdjustment } from '@app/shared/types/sf-data'

import { computed } from 'vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SubAdjustment',
})

interface Props {
  item: SubAdjustment
}

const props = defineProps<Props>()

const credit = computed(() => {
  return props.item.valueCredit ? props.item.valueCredit : '&mdash;'
})

const debit = computed(() => {
  return props.item.valueDebit ? props.item.valueDebit : '&mdash;'
})
</script>
